
import React from 'react';
import { usePhemexLang } from '@/contexts/PhemexLangContext';
import { 
  CheckCircle2, 
  Shield, 
  LineChart, 
  Clock, 
  Zap, 
  HeadphonesIcon 
} from 'lucide-react';

const WhyMetradeSection = () => {
  const { t } = usePhemexLang();
  
  const reasons = [
    {
      icon: <CheckCircle2 size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason1.title,
      description: t.whyMetrade.reason1.description
    },
    {
      icon: <Shield size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason2.title,
      description: t.whyMetrade.reason2.description
    },
    {
      icon: <Clock size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason3.title,
      description: t.whyMetrade.reason3.description
    },
    {
      icon: <Zap size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason4.title,
      description: t.whyMetrade.reason4.description
    },
    {
      icon: <LineChart size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason5.title,
      description: t.whyMetrade.reason5.description
    },
    {
      icon: <HeadphonesIcon size={24} style={{ color: '#38d102' }} />,
      title: t.whyMetrade.reason6.title,
      description: t.whyMetrade.reason6.description
    }
  ];

  return (
    <div className="py-16 px-4 bg-black">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-2" style={{ color: '#38d102' }}>
          {t.whyMetrade.title}
        </h2>
        <p className="text-center text-gray-300 mb-12">
          {t.whyMetrade.subtitle}
        </p>
        
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reasons.map((reason, index) => (
            <div 
              key={index} 
              className="bg-black border border-gray-800 rounded-lg p-6 transition-transform hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="flex items-start mb-4">
                <div className="bg-gray-800 p-3 rounded-lg mr-4">
                  {reason.icon}
                </div>
                <h3 className="text-xl font-bold text-white">{reason.title}</h3>
              </div>
              <p className="text-gray-400 pl-14">
                {reason.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyMetradeSection;
